import React from 'react'
import TagIcon from '@material-ui/icons/LocalOfferOutlined'
import TranslationLabel from '../core/components/TranslationLabel'

const priceEnum = {
  Standard: 0,
  Campaign: 1,
  Archive: 2,
}

function getCampaignQuantity(product) {
  // Check if priceDtos array exists and has items
  if (product.priceDtos && product.priceDtos.length > 0) {
      // Filter priceDtos for entries where priceType is 1
      const filteredPrices = product.priceDtos.filter(price => price.priceType === 1);

      if (filteredPrices.length > 0) {
          // Find the lowest priceValidFromQuantity
          const lowestQuantity = Math.min(
              ...filteredPrices.map(price => price.priceValidFromQuantity)
          );
          return lowestQuantity;
      }
  }

  // If no priceType = 1 is found, return quantity
  return product.quantity;
}

function findPrice(quantity, product) {
  let _currentPrice = {}

  product.priceDtos.forEach((price) => {
    if (
      price.priceValidFromQuantity <= quantity &&
      price.priceValidFromQuantity > 0
    ) {
      _currentPrice = price
    }
  })

  return _currentPrice
}

function findCampaignId(product, quantity) {
  let _campaignId = null

  product.priceDtos.forEach((price) => {
    if (
      price.priceValidFromQuantity <= quantity &&
      price.priceValidFromQuantity > 0
    ) {
      _campaignId = price.campaignId
    }
  })

  return _campaignId
}

function hasNoPrice(product) {
  return !product.priceDtos.length
}

function findNextAllowedQuantity(product, quantity) {
  const {
    minimumQuantity,
    multiplesQuantity,
    colli,
  } = product

  return findNextAllowedQuantityByQuantities(
    minimumQuantity,
    multiplesQuantity,
    colli,
    quantity,
  )
}

function findNextAllowedQuantityByQuantities(
  minimumQuantity,
  multiplesQuantity,
  colli,
  quantity,
) {
  if (quantity < 1) {
    return 0
  }

  if (quantity <= minimumQuantity) {
    return minimumQuantity
  }

  let increment = 1

  if (quantity > colli) {
    if (quantity >= multiplesQuantity)
      increment = multiplesQuantity
    else
      increment = colli
  }

  return Math.round(quantity / increment) * increment
}

function GetNextIncrementQuantity(product, quantity) {
  const {
    minimumQuantity,
    multiplesQuantity,
    colli
  } = product

  return GetNextIncrementQuantityByQuantities(
    minimumQuantity,
    multiplesQuantity,
    colli,
    quantity,
  )
}

function GetNextIncrementQuantityByQuantities(
  minimumQuantity,
  multiplesQuantity,
  colli,
  currentQuantity,
) {
  const quantity = currentQuantity + 1
  if (quantity < 1) {
    return 1
  }

  if (quantity < minimumQuantity) {
    return minimumQuantity
  }

  let increment = 1

  if (quantity > colli) {
    if (quantity >= multiplesQuantity)
      increment = multiplesQuantity
    else
      increment = colli
  }

  return Math.round(currentQuantity + increment)
}

function GetNextDecrementQuantity(product, quantity) {
  const {
    minimumQuantity,
    multiplesQuantity,
    colli
  } = product

  return GetNextDecrementQuantityByQuantities(
    minimumQuantity,
    multiplesQuantity,
    colli,
    quantity,
  )
}

function GetNextDecrementQuantityByQuantities(
  minimumQuantity,
  multiplesQuantity,
  colli,
  currentQuantity,
) {
  const quantity = currentQuantity - 1

  if (quantity < 1) {
    return 1
  }

  if (quantity < minimumQuantity) {
    return minimumQuantity
  }

  let decrement = 1

  if (quantity > colli) {
    if (quantity >= multiplesQuantity)
      decrement = multiplesQuantity
    else
      decrement = colli
  }

  return Math.round(currentQuantity - decrement)
}

function hasDiscount(currentPrice) {
  return currentPrice.discountPercentage > 0
}

function RenderPriceTag(currentPrice) {
  if (
    currentPrice.priceType == undefined ||
    currentPrice.priceType == priceEnum.Standard
  ) {
    return
  }

  return (
    <>
      <TagIcon
        style={{
          color: currentPrice.priceType == priceEnum.Campaign ? 'green' : 'red',
          verticalAlign: 'middle',
          width: 16,
          height: 16,
          marginLeft: 6,
        }}
      />
      <span
        style={{
          color: currentPrice.priceType == priceEnum.Campaign ? 'green' : 'red',
          fontSize: 12,
        }}>
        {currentPrice.priceType == priceEnum.Campaign ? (
          <TranslationLabel name='campaignPrice' />
        ) : (
          <TranslationLabel name='ArchivePrice' />
        )}
      </span>
    </>
  )
}

function nextPriceTag(quantity, product) {
  const nextPrice = product.priceDtos.find(
    (el) =>
      el.priceValidFromQuantity > quantity &&
      (el.priceType == priceEnum.Archive || el.priceType == priceEnum.Campaign),
  )

  if (!nextPrice) {
    return
  }

  return (
    <>
      <TagIcon
        style={{
          color: nextPrice.priceType == priceEnum.Campaign ? 'green' : 'red',
          verticalAlign: 'middle',
          width: 20,
          height: 20,
          marginLeft: 6,
        }}
      />
      <span
        style={{
          color: nextPrice.priceType == priceEnum.Campaign ? 'green' : 'red',
        }}>
        {nextPrice.priceValidFromQuantity}
        <TranslationLabel name='productsUnit' />+
      </span>
    </>
  )
}

function renderPrice(currentPrice, classes) {
  return (
    <>
      {hasDiscount(currentPrice) ? (
        <div>
          <del className={classes.priceNormal}>{currentPrice.grossPrice}</del>
          {RenderPriceTag(currentPrice)}
        </div>
      ) : (
        <span className={classes.priceNormal}>
          <TranslationLabel name='price' />
          {RenderPriceTag(currentPrice)}
        </span>
      )}
    </>
  )
}

function renderYourPrice(currentPrice, quantity, classes) {
  return (
    <div>
      <span className={classes.priceYours}>{currentPrice.netPrice}</span>
      <span className={classes.priceText}>
        {hasDiscount(currentPrice) ? (
          <span>
            <TranslationLabel name='price' />
          </span>
        ) : (
          ''
        )}{' '}
        <TranslationLabel name='productsQuantityPrefix' /> {quantity || 0}
        <TranslationLabel name='productsUnit' />
      </span>
    </div>
  )
}

export default {
  getCampaignQuantity,
  findPrice,
  findCampaignId,
  hasNoPrice,
  findNextAllowedQuantity,
  findNextAllowedQuantityByQuantities,
  GetNextIncrementQuantity,
  GetNextIncrementQuantityByQuantities,
  GetNextDecrementQuantity,
  GetNextDecrementQuantityByQuantities,
  hasDiscount,
  RenderPriceTag,
  nextPriceTag,
  renderPrice,
  renderYourPrice,
  priceEnum,
}
